import { Subject } from 'rxjs';
import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { Machine } from '../machine/machine';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MachineService } from '../machine/machineService';
import { Ticket } from '../ticket/ticket';
import { TicketService } from '../ticket/ticketService';
import { State } from '../state/state';
import { StateService } from '../state/stateService';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '../_services/user.service';
import { ClientService } from '../client/clientservice';
import { User } from '../user/user';
import { Client } from '../client/client';
import { Authenticate } from '../authenticate/authenticate';
import { LocationService } from '../location/locationService';
import { Location } from '../location/location';
import htmlToPDFmake from 'html-to-pdfmake';
import { DatePipe } from '@angular/common';
import { Logo } from '../ticketview/logo';
import pdfMake from 'pdfmake/build/pdfmake';
import { MachineList } from './machinelist';
import { collectVariableUsage } from 'node_modules/tsutils';
import { CollapseModule } from 'ngx-bootstrap';


@Component({
    selector: 'app-machineslistview',
    templateUrl: './machineslistview.component.html',
    styleUrls: ['../app.component.less', '../machine/machine.component.less', './machineslistview.component.css']
})
export class MachineslistviewComponent implements OnInit {



    //#region Variables
    //---------------------------------------------------------------------------
    //PUBLIC and PRIVATE VARIABLE DECLARATIONS
    //---------------------------------------------------------------------------
    @Input() inMachines: Machine[];
    @Input() inClient: Client;
    machines: Machine[];
    machine = new Machine;
    location: Location;
    tickets: Ticket[];
    _states: State[];
    _selectedstateid: number;
    state = new State;
    querycriteria: string;
    searchquery: string;
    currentuser: User;
    currentclient: Client;
    auth: Authenticate;
    private userRole: string;
    private jwt: string;
    private userrole: string;
    locations: Location[];
    selectedLocation: string;
    p: Number = 1;
    count: Number = 15;
    pdfmake = pdfMake;
    collapse = false;
    _list: MachineList[] = [];
    tableHeader: String[];
    tableContent: String[];
    isAdmin = false;

    showId = true;
    showClient = true;
    showMachine = true;
    showLocation = true;
    showSerial = true;
    showModel = true;
    showState = true;
    isLoading: boolean = true; // Declare the loading state


    externalDataRetrievedFromServer = [
        { name: 'Bartek', age: 34 },
        { name: 'John', age: 27 },
        { name: 'Elizabeth', age: 30 },
    ];

    //#endregion

    //---------------------------------------------------------------------------
    // CLASS CONSTRUCTOR
    //---------------------------------------------------------------------------

    constructor(private http: HttpClient,
        private route: ActivatedRoute,
        private machineservice: MachineService,
        private ticketservice: TicketService,
        private stateservice: StateService,
        private userservice: UserService,
        private clientservice: ClientService,
        private locationservice: LocationService,
        private router: Router,
        private activateroute: ActivatedRoute,
        private datePipe: DatePipe) { }

    //---------------------------------------------------------------------------
    // On Init Function (PAGE LOAD)
    //---------------------------------------------------------------------------




    async ngOnInit() {

        console.log("IS LOADING" + this.isLoading);
        this.querycriteria = "shortname";
        this.currentclient = this.inClient;
        this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
        this.jwt = this.auth.jwt;
        let role = this.auth.user.role.name;
        this.currentuser = this.auth.user;
        this.userrole = role;

        if (role == "Authenticated" || this.userrole == "Administrator") {
            if (this.auth.user.privilege == "1") { this.isAdmin = true; }

            // Geting the URL parameter if present id > 0 
            const id = +this.activateroute.snapshot.paramMap.get('id');
            // IF NO ID IS SET WE GET ALL 
            if (id == 0) {
                this.machineservice.getMachines().subscribe(machines => {
                    this.machines = machines;
                    this.isLoading = false;
                });
                this.locationservice.getLocations().subscribe(response => this.locations = response);
                this.inClient = this.currentuser.client;
            }
            // ID CLIENT ID IS DEFINED IN THE ACTIVATED ROUTE
            else if (id > 0) {
                await this.machineservice.getClientMachines(id).subscribe(resp => this.machines = resp);
                await this.locationservice.getLocationsByClId(id).subscribe(resp => this.locations = resp);
                this.isLoading = false;
            }
        }
        // IF CLIENT LOGIN
        else {
            if (role = "clientsrole") {
                var cID = this.currentuser.client.id;
                await this.clientservice.getClientById(cID).subscribe(resp => this.currentclient = resp);
                await this.machineservice.getMachineByClientID(cID).subscribe(resp => this.machines = resp);
                await this.locationservice.getLocationsByClId(cID).subscribe(resp => this.locations = resp);
                this.isLoading = false;
            } else {

            }
        }
    }



    //---------------------------------------------------------------------------
    // Search Function with using variable criteria
    //---------------------------------------------------------------------------

    search(shortname) {

        if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
            this.machineservice.getMachineByCriteriaAdmin(this.querycriteria, shortname, this.jwt).subscribe(machines => this.machines = machines);

        } else {
            this.machineservice.getMachineByCriteria(this.querycriteria, shortname, this.currentuser.client.id, this.jwt).subscribe(machines => this.machines = machines);
        }
        this.p = 1;

    }


    //---------------------------------------------------------------------------
    // Update Machine Location details 
    //---------------------------------------------------------------------------

    locChanged(): void {
        var seek = this.selectedLocation.substring(0, this.selectedLocation.indexOf(':'));

        if (this.userrole == "Authenticated" || this.userrole == "Administrator") {
            this.machineservice.getMachineByLocationIdAdmin("location", seek, this.jwt).subscribe(machines => this.machines = machines);

        } else {
            this.machineservice.getMachineByLocationId("location", seek, this.currentuser.client.id, this.jwt).subscribe(machines => this.machines = machines);
        }
        this.p = 1;
    }

    //---------------------------------------------------------------------------
    // Export Machines List to PDF Document and open in a new page
    //---------------------------------------------------------------------------

    onExportClick() {
        this.populatePdf();

        var lg: Logo;
        lg = new Logo;
        var strlg: string;
        strlg = lg.versystech();
        var column = [];
        column.push({ text: 'A', style: 'tableHea–der' });
        column.push({ text: 'B', style: 'tableHeader' });

        var value = [];
        value.push({ text: 'Asda', style: 'tableHeader' });
        value.push({ text: 'Bsa', style: 'tableHeader' });
        var machinestable = document.getElementById('machineslist');

        var pdfcontent = htmlToPDFmake(machinestable.innerHTML);

        this.pdfmake.tableLayouts = {
            exampleLayout: {
                hLineWidth: function (i, node) {
                    if (i === 0 || i === node.table.body.length) {
                        return 0;
                    }
                    return (i === node.table.headerRows) ? 2 : 1;
                },
                vLineWidth: function (i) {
                    return 0;
                },
                hLineColor: function (i) {
                    return i === 1 ? 'black' : '#aaa';
                },
                paddingLeft: function (i) {
                    return i === 0 ? 0 : 8;
                },
                paddingRight: function (i, node) {
                    return (i === node.table.widths.length - 1) ? 0 : 8;
                }
            }
        };

        //  var pdfresolution = htmlToPDFmake(this.ticket.resolution);
        const documentDefinition = {
            styles:
            {
                header: {
                    fontSize: 18,
                    bold: true
                },
                bigger: {
                    fontSize: 14,
                    bold: true
                }
                ,
                tableHeader:
                {
                    bold: true,
                    fillColor: '#555555'

                },
                defaultStyle: {
                    columnGap: 20
                }
            },
            content: [{
                image: strlg,
                width: 150
            },
                "\n", { style: 'header', alignment: 'center', text: "" + this.inClient?.name },
                "\n", { style: 'bigger', alignment: 'center', text: 'Client Machines List \n\n' },

            { text: '', style: 'header' },
            this.table(this._list, this.tableHeader),

            ]
        };
        this.pdfmake.createPdf(documentDefinition).open();
    }


    //---------------------------------------------------------------------------
    // Fill the pdf document content 
    //---------------------------------------------------------------------------

    populatePdf() {
        this.tableHeader = ['id', 'client', 'shortname', 'serialnumber', 'state'];
        //this.tableHeader = 

        //var tblhead = [{text: 'Header 1', style: 'tableHeader'}, {text: 'Header 2', style: 'tableHeader'}, {text: 'Header 3', style: 'tableHeader'}];
        var i = 0;
        this._list = [];

        while (i < this.machines.length) {
            let temp: MachineList = new MachineList;


            temp.shortname = this.machines[i].shortname;

            if (this.machines[i].serialnumber) {
                temp.serialnumber = this.machines[i]?.serialnumber;
            } else {
                temp.serialnumber = "N/A";
            }

            if (this.machines[i].state) {
                temp.state = this.machines[i].state?.statevalue;
            }
            else {
                temp.state = "N/A";
            }
            temp.client = this.machines[i].client.name;
            temp.id = this.machines[i].id;

            this._list[i] = temp;


            i++;
        }

    }

    //---------------------------------------------------------------------------
    // Build the Table Body that populates the PDF File
    //---------------------------------------------------------------------------

    buildTableBody(data, columns) {
        var body = [];
        body.push(columns);
        data.forEach(function (row) {
            var dataRow = [];
            columns.forEach(function (column) {
                dataRow.push(row[column].toString());
            })
            body.push(dataRow);
        });
        return body;
    }

    //---------------------------------------------------------------------------
    // Create Table Rows and Columns for the PDF output
    //---------------------------------------------------------------------------

    table(data, columns) {
        return {
            layout: {
                fillColor: 'lightgrey',
                fillOpacity: function (rowIndex) {
                    if (rowIndex == 0) {
                        return 100;
                    }
                    else { return 0; }
                }
            },

            table: {
                headerRows: 1,
                body: this.buildTableBody(data, columns)
            },

        };
    }

}